import React, { FC, memo, useState } from 'react';
import { Radio } from 'udesk-ui';
import ParamsList, { ListItem } from '../ParamsList';
import styled from 'styled-components';

const Wrapper = styled.div``;

const Content = styled.div`
    margin-top: 10px;
`;

interface TemplateProps {
    value?: {
        requestQueryList?: ListItem[];
        requestHeaderList?: ListItem[];
        requestBodyList?: ListItem[];
    };
    onChange?: (value: TemplateProps['value']) => void;
    dataSourceList?: number[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, dataSourceList } = props;

    const [curType, setCurType] = useState<'Query' | 'Header' | 'Body'>('Query');

    const onRequestQueryListChange = (requestQueryList?: ListItem[]) => {
        const newValue = {
            ...value,
            requestQueryList,
        };

        onChange?.(newValue);
    };

    const onRequestHeaderListChange = (requestHeaderList?: ListItem[]) => {
        const newValue = {
            ...value,
            requestHeaderList,
        };

        onChange?.(newValue);
    };

    const onRequestBodyListChange = (requestBodyList?: ListItem[]) => {
        const newValue = {
            ...value,
            requestBodyList,
        };

        onChange?.(newValue);
    };

    return (
        <Wrapper>
            <Radio.Group
                optionType="button"
                value={curType}
                onChange={(e) => setCurType(e.target.value)}
                options={[
                    {
                        label: 'Query',
                        value: 'Query',
                    },
                    {
                        label: 'Header',
                        value: 'Header',
                    },
                    {
                        label: 'Body',
                        value: 'Body',
                    },
                ]}
            />

            <Content>
                {curType === 'Query' ? (
                    <ParamsList
                        valueType="special1"
                        dataSourceList={dataSourceList}
                        value={value?.requestQueryList}
                        onChange={onRequestQueryListChange}
                    />
                ) : curType === 'Header' ? (
                    <ParamsList
                        value={value?.requestHeaderList}
                        onChange={onRequestHeaderListChange}
                    />
                ) : curType === 'Body' ? (
                    <ParamsList
                        valueType="special1"
                        dataSourceList={dataSourceList}
                        value={value?.requestBodyList}
                        onChange={onRequestBodyListChange}
                    />
                ) : null}
            </Content>
        </Wrapper>
    );
});

export default Template;
